<template>
  <v-dialog
    v-model="dialogSelectaccount"
    width="500"
    style="border-radius:10px;"
    persistent
  >
    <v-card style="border-radius:10px; !important">
      <v-toolbar color="white" style="border-top-left-radius: 10px !important; border-top-right-radius: 10px; ">
        <v-toolbar-title>{{$t('Dialog.selectaccount.title1')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon style="cursor:pointer;" @click="closeSelectaccount()">close</v-icon>
      </v-toolbar>

      <div class="padding-text">
        <h3>{{$t('Dialog.selectaccount.title2')}}</h3>
      </div>
      <div class="scrolling-wrapper" style="overflow-y:auto; height:400px; ">
        <v-list three-line>
          <!-- <v-radio-group  v-model="selectedItem" :mandatory="true"> -->
          <!-- <template v-for="(item, index) in items"> -->
          <template v-for="(item, index) in list_accounts">
            <v-list-tile
              :key="index"
              avatar
              @click="itemType(item,index)"
              :class="{ active: index === activeItem}"
            >
              <!-- <v-list-tile-action>
                <v-radio :value="item" :key="item.id"></v-radio>
              </v-list-tile-action> -->

              <v-list-tile-avatar>
                <img v-if="item.profilepicture" :src="item.profilepicture">
                <img v-else src='/static/img/default_profile/man-white.png'>
              </v-list-tile-avatar>

              <v-list-tile-content>
              <v-list-tile-title v-if="item.username">{{item.username}}</v-list-tile-title>
              <v-list-tile-title v-else>{{item.email}}</v-list-tile-title>
                <v-list-tile-sub-title>{{item.email}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <!-- </v-radio-group> -->
        </v-list>
      </div>
      <div class="padding-text" style="padding-right:16px; text-transform: none;">
        <v-layout justify-end>
          <v-btn round color="primary" @click="selectAccount()" :loading="loading" :disabled="disableBTN()" style="color:white; text-transform: none;">{{$t('AnswerQuestion.login')}}</v-btn>
          <v-btn style="text-transform: none;" dark round color="red" @click="closeSelectaccount()">{{$t('AnswerQuestion.cancel')}}</v-btn>
        </v-layout>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { Encode } from '@/services'
export default {
  props: {
    dialogSelectaccount: Boolean,
    list_accounts: Array,
    phoneNumber: String
  },
  data () {
    return {
      selectedItem: '',
      items: [
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            username: 'Brunch this weekend?',
            email: "fdgdfgdgfgd",
            one_id:'1'
          },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
            username: 'Summer BBQ',
            email: "dfgfdgdgdgdf",
            one_id:'2'
          },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
            username: 'Oui oui',
            email: "asaddssdadasdsd",
            one_id: '3'
          },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
            username: null,
            email: "ssssssssssssssssss",
            one_id: '4'
          },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
            username: '',
            email: "asaSasASAsadasds",
            one_id: '5'
          }
        ],
        myprofilepicture: '',
        myname: '',
        isLoading: false,
        nameShowalert: '',
        loading: false,
        activeItem: null
    }
  },
  watch:{
    // selectedItem (val) {
    //   this.selectedItem = val
    //   console.log('val' , val)
    //   // this.$store.commit('item/setIteminStore', payload)
    // }
    dialogSelectaccount () {
      console.log(this.dialogSelectaccount)
      if (this.dialogSelectaccount) {
        // this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
        this.$i18n.locale = 'th'
      }
    }
  },
  created () {
    // this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
    this.$i18n.locale = 'th'
    console.log(`this.$i18n.locale: ${this.$i18n.locale}`)
  },
  methods :{
    // selectItem(i) {
    //   this.activeItem = i;
    // },
    itemType(payload, i) {
      // console.log(payload.one_id)
      this.selectedItem = payload
      this.activeItem = i;
    },
    disableBTN() {
      if(this.selectedItem == ''){
        return true
      }else{
        return false
      }
    },
    closeSelectaccount() {
      this.$emit('closeSelectaccount', false)
    },
    selectAccount() {
      this.loading = true
      if(this.selectedItem.username === '' || this.selectedItem.username === null){
        // console.log('test :', this.selectedItem.username)
        this.nameShowalert = this.selectedItem.email
      }else{
        this.nameShowalert = this.selectedItem.username
      }
      this.$swal({
        title: `<span style=" font-family: CS ChatThaiUI !important;">${this.$t('Dialog.selectaccount.alert.title')}</span>`,
        html: `<span style=" font-family: CS ChatThaiUI !important;"> ${this.$t('Dialog.selectaccount.alert.text1')} `+ '<b  style="font-size: 18px;font-weight: bold; color:#3085d6;">'+ this.nameShowalert +'</b>' + ` ${this.$t('Dialog.selectaccount.alert.text2')}?</span>`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: 'grey',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        // console.log(result.value)
        if(result.value === true){
          var data = {
            type_otp: "set accounts",
            phone : this.phoneNumber,
            one_id: this.selectedItem.one_id,
          }
          // console.log(data)
          this.axios.post(process.env.APImanage + '/v2/login_and_regis', data)
          .then((response) => {
            if(response.data.status === 'success') {
              var profile = response.data['account']['profile']
              this.myprofilepicture = profile['profilepicture']
              this.myname = profile['name']
              // this.$cookie.set('language', 'th')
              this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
              localStorage.setItem('Authenrization', Encode.encode({'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type']}))
              localStorage.setItem('profilepicture', profile['profilepicture'])
              localStorage.setItem('name', profile['name'])
              localStorage.setItem('phone', profile['phone'])
              localStorage.setItem('email', profile['email'])
              localStorage.setItem('status', profile['status'])
              localStorage.setItem('type_user', profile['type'])
              localStorage.setItem('wallpaperInfo', JSON.stringify({
                'info': [{
                  'room': '',
                  'background': ''
                }]
              }))
              if (profile['username'] === '' || profile['username'] === 'None') {
                localStorage.setItem('status_username', 'false')
              } else {
                localStorage.setItem('status_username', 'true')
              }
              this.loading = false
              if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
                this.$router.push('/chat')
              } else {
                this.$router.push(localStorage.getItem('pathRoom'))
              }
            }
         })
       } else {
         this.loading = false
       }
      })
    },
    selectAccount2() {
      if(this.selectedItem.username === '' || this.selectedItem.username === null){
        console.log('test :', this.selectedItem.username)
        this.nameShowalert = this.selectedItem.email
      }else{
        this.nameShowalert = this.selectedItem.username
      }
      this.$swal({
        title: '<span style=" font-family: CS ChatThaiUI !important;">ยืนยันการเลือกบัญชีเข้าใช้งาน?</span>',
        html: '<span style=" font-family: CS ChatThaiUI !important;"> คุณต้องการใช้บัญชี '+ '<b  style="font-size: 18px;font-weight: bold; color:#3085d6;">'+ this.nameShowalert +'</b>' + ' ในการเข้าใช้งาน OneChat ใช่หรือไม่?</span>',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: 'grey',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        console.log(result.value)
        if(result.value === true){
          var test = {
            account : {
              profile: {
              account_title_eng: "Miss",
              account_title_th: "นางสาว",
              email: "jantakarn.siv@one.th",
              first_name_eng: "jantakarn",
              first_name_th: "จันทกานติ์",
              id_card_num: "XXXXXX0213531",
              id_card_type: "ID_CARD",
              ip: "172.24.9.54:8998",
              last_name_eng: "sivilize",
              last_name_th: "ศิวิลัยซ์",
              loa: "loa0",
              name: "jantakarn.siv@one.th",
              nickname: "jantakarn.siv@one.th",
              one_id: "100512130944",
              phone: "0905769269",
              profilepicture: "https://testchat.one.th/alpine/api/v1/file/jyc3K7o6nxU6c00766dad3c5b9cb8facfd06d702d45_2020-06-26_10:15:11:049748.png",
              status: "",
              tokenservice: "Aa515b790db355f35a1127f1636d28b49c6402e15cf1040ffb81e900c63e6df13260cf9269f7b4088929c057cce3b415d",
              tokenuser: "U6c00766dad3c5b9cb8facfd06d702d45",
              type: "user",
              username: "jantakarnss",
              }
            }
          }
          var profile = test['account']['profile']
          // console.log('Profile :' , profile)
          this.myprofilepicture = profile['profilepicture']
          // console.log(this.myprofilepicture)
          this.myname = profile['name']
          this.$cookie.set('language', 'th')
          localStorage.setItem('Authenrization', Encode.encode({'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type']}))
          localStorage.setItem('profilepicture', profile['profilepicture'])
          localStorage.setItem('name', profile['name'])
          localStorage.setItem('phone', profile['phone'])
          localStorage.setItem('email', profile['email'])
          localStorage.setItem('status', profile['status'])
          localStorage.setItem('type_user', profile['type'])
          if (profile['username'] === '' || profile['username'] === 'None') {
            localStorage.setItem('status_username', 'false')
          } else {
            localStorage.setItem('status_username', 'true')
          }
          this.isLoading = false
          if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
            this.$router.push('/chat')
          } else {
            this.$router.push(localStorage.getItem('pathRoom'))
          }
        }
      })


      // var username = 'jantakarnSivi'
      // this.$cookie.set('language', 'th')
      // localStorage.setItem('Authenrization','9JiclNXdiojIyV2c19VZwlHdiwiIUJiOi4Wan9GbfNXd0FGdzJCLiUDNkJDM3QmNwQmZjFmZ4I2Y5IWNjNDZhRmN2cDMwMmNVJiOiIXZzVnblt2b0JyeAe5pBp2')
      // localStorage.setItem('profilepicture', 'https://testchat.one.th/alpine/api/v1/file/jyc3K7o6nxU6c00766dad3c5b9cb8facfd06d702d45_2020-06-26_10:15:11:049748.png')
      // localStorage.setItem('name', 'jantakarn.siv@one.th')
      // localStorage.setItem('phone', '0905769269')
      // localStorage.setItem('email', 'jantakarn.siv@one.th')
      // localStorage.setItem('status', "")
      // localStorage.setItem('type_user', "type_user")
      // if (username === '' || username === 'None') {
      //   localStorage.setItem('status_username', 'false')
      // } else {
      //   localStorage.setItem('status_username', 'true')
      // }
      //   this.isLoading = false
      //   if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
      //     this.$router.push('/chat')
      //   } else {
      //     this.$router.push(localStorage.getItem('pathRoom'))
      //   }
    }
  }
}
</script>

<style scoped>
>>>.v-toolbar__title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: .02em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.padding-text{
  padding-top:16px;
  padding-bottom:16px;
  padding-left:16px;
}
>>>.v-list__tile__content {
    text-align: left;
    flex: 1 1 auto;
    overflow: hidden;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    width: 350px;
}
/* .swal2-popup {
  font-family: 'CS ChatThaiUI' !important;
} */

/* >>>.swal-title {
  font-family: 'CS ChatThaiUI';
  margin: 0px;
  font-size: 16px;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.21);
  margin-bottom: 28px;
  background-color: teal;
} */

/* >>>.swal2-popup .swal2-title {
    font-family:'CS ChatThaiUI';
    display: block;
    position: relative;
    max-width: 100%;
    margin: 0 0 .4em;
    padding: 0;
    color: #595959;
    font-size: 1.875em;
    font-weight: 600;
    text-align: center;
    text-transform: none;
    word-wrap: break-word;
} */

/* >>>.swal2-popup {
    display: none;
    position: relative;
    flex-direction: column;
    justify-content: center;
    width: 32em;
    max-width: 100%;
    padding: 1.25em;
    border-radius: .3125em;
    background: #fff;
    font-family: 'CS ChatThaiUI' !important;
    font-size: 1rem;
    box-sizing: border-box;
} */
>>>.h2#swal2-title.swal2-title{
  font-family: 'CS ChatThaiUI' !important;
}

.active {
  /* padding: 5px; */
  background-color: #BBDEFB
}

.v-list {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/SelectAccount.vue